var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRponses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45354 21.2867V10.2288H4.30685C3.20708 10.2288 2.15235 10.6657 1.37469 11.4434C0.597039 12.221 0.160156 13.2757 0.160156 14.3755V39.2557C0.162213 39.5124 0.235719 39.7634 0.372434 39.9807C0.50915 40.198 0.703673 40.3729 0.934206 40.4859C1.1563 40.5869 1.40117 40.6273 1.64395 40.603C1.88672 40.5787 2.11874 40.4906 2.31644 40.3476L9.43493 35.109H28.0121C28.536 35.1245 29.0575 35.0322 29.5443 34.838C30.031 34.6438 30.4728 34.3516 30.8421 33.9797C31.2114 33.6079 31.5004 33.1641 31.6912 32.676C31.882 32.1878 31.9706 31.6657 31.9515 31.142V29.5801H16.7469C14.5474 29.5801 12.4379 28.7063 10.8826 27.151C9.32731 25.5957 8.45354 23.4862 8.45354 21.2867Z",
    fill: "#E0861B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2451 0.553223H16.7471C15.6474 0.553223 14.5926 0.990105 13.815 1.76776C13.0373 2.54542 12.6004 3.60015 12.6004 4.69992V21.2867C12.6004 22.3865 13.0373 23.4412 13.815 24.2188C14.5926 24.9965 15.6474 25.4334 16.7471 25.4334H35.4764L42.0834 30.5615C42.2798 30.7067 42.5112 30.7973 42.754 30.824C42.9968 30.8507 43.2424 30.8126 43.4657 30.7135C43.7009 30.6015 43.8996 30.4253 44.039 30.2052C44.1784 29.9851 44.2528 29.73 44.2535 29.4695V4.69992C44.2541 3.62368 43.8363 2.58937 43.0883 1.81557C42.3402 1.04177 41.3207 0.589097 40.2451 0.553223Z",
    fill: "#E0861B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRponses);
export default __webpack_public_path__ + "static/media/Réponses.20b20af66231163edc559571bedf797e.svg";
export { ForwardRef as ReactComponent };